// "Always download" preference + auto-trigger for the offline archive.
// Mirrors iOS's `AppSettings.alwaysDownloadArchive` toggle. When ON,
// every page load (after auth hydrates) runs `runArchiveDownload` once
// in the background. The downloader is idempotent — already-pinned
// (date, difficulty) pairs are skipped — so subsequent loads are cheap.

import { runArchiveDownload } from './archiveDownloader';

const STORAGE_KEY = 'hm.alwaysDownload.v1';

// Module-level guards. Route swaps remount AuthProvider; without these
// every navigation would kick off a new sweep.
let inFlight = false;
let done = false;

export function getAlwaysDownloadEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try { return localStorage.getItem(STORAGE_KEY) === '1'; }
  catch { return false; }
}

export function setAlwaysDownloadEnabled(on: boolean): void {
  if (typeof window === 'undefined') return;
  try { localStorage.setItem(STORAGE_KEY, on ? '1' : '0'); }
  catch { /* ignore */ }
}

/// Fire-and-forget. Safe to call on every route mount — the module-level
/// `inFlight` / `done` flags collapse repeat calls. Caller is expected
/// to gate on `auth.user?.isPremium`; this function doesn't check.
export function maybeRunAlwaysDownload(): void {
  if (inFlight || done) return;
  if (!getAlwaysDownloadEnabled()) return;
  inFlight = true;
  void runArchiveDownload(null, () => { /* no UI surface for the quiet variant */ })
    .finally(() => { inFlight = false; done = true; });
}
